export enum SubscriptionTypeEnum {
    SUBSCRIBE_BUNDLE = 'subscribeBundles',
    SUBSCRIBE_MOBILE = 'subscribeMobileStandalone',
    CHECK_COVERAGE = 'checkCoverage'
}

export enum ScopeEnum {
    STANDALONE = 'standalone',
    BUNDLE = 'bundle'
}

export enum ModalityEnum {
    PREPAID = 'prepaid',
    POSTPAID = 'postpaid'
}

export enum SubscriptionStepsEnum {
    SERVICEABILITY = 'serviceability',
    MANAGE_OFFERS = 'manageOffers'
}

export enum MediaQueryEnum {
    MOBILE = 'mobile',
    TABLET = 'tablet',
    DESKTOP = 'desktop',
    SUPER_DESKTOP = 'superDesktop'
}

export enum MarketSegmentEnum {
    AMIGO = 'Amigo',
    VODAFONE = 'Vodafone'
}
